"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Figcaption = exports.ExtraStrongText = exports.StrongText = exports.EmText = exports.OverlineThreeText = exports.OverlineTwoText = exports.OverlineOneText = exports.BodyFourText = exports.BodyThreeText = exports.BodyTwoText = exports.BodyOneText = exports.Heading6 = exports.Heading5 = exports.Heading4 = exports.Heading3 = exports.Heading2 = exports.Heading1 = void 0;
var react_1 = __importDefault(require("react"));
var Typography_1 = __importDefault(require("./Typography"));
var typographyElementsToGenerate = [
    {
        displayName: 'Heading1',
        semanticTag: 'h1',
        defaultVisualAppearance: 'heading-xxl',
    },
    {
        displayName: 'Heading2',
        semanticTag: 'h2',
        defaultVisualAppearance: 'heading-xl',
    },
    {
        displayName: 'Heading3',
        semanticTag: 'h3',
        defaultVisualAppearance: 'heading-lg',
    },
    {
        displayName: 'Heading4',
        semanticTag: 'h4',
        defaultVisualAppearance: 'heading-md',
    },
    {
        displayName: 'Heading5',
        semanticTag: 'h5',
        defaultVisualAppearance: 'heading-sm',
    },
    {
        displayName: 'Heading6',
        semanticTag: 'h6',
        defaultVisualAppearance: 'heading-xs',
    },
    {
        displayName: 'BodyOneText',
        semanticTag: 'p',
        defaultVisualAppearance: 'body-one',
    },
    {
        displayName: 'BodyTwoText',
        semanticTag: 'p',
        defaultVisualAppearance: 'body-two',
    },
    {
        displayName: 'BodyThreeText',
        semanticTag: 'p',
        defaultVisualAppearance: 'body-three',
    },
    {
        displayName: 'BodyFourText',
        semanticTag: 'p',
        defaultVisualAppearance: 'body-four',
    },
    {
        displayName: 'OverlineOneText',
        semanticTag: 'p',
        defaultVisualAppearance: 'overline-one',
    },
    {
        displayName: 'OverlineTwoText',
        semanticTag: 'p',
        defaultVisualAppearance: 'overline-two',
    },
    {
        displayName: 'OverlineThreeText',
        semanticTag: 'p',
        defaultVisualAppearance: 'overline-three',
    },
    { displayName: 'EmText', semanticTag: 'em', defaultVisualAppearance: 'em' },
    {
        displayName: 'StrongText',
        semanticTag: 'strong',
        defaultVisualAppearance: 'strong',
    },
    {
        displayName: 'ExtraStrongText',
        semanticTag: 'strong',
        defaultVisualAppearance: 'extra-strong',
    },
    {
        displayName: 'Figcaption',
        semanticTag: 'figcaption',
        defaultVisualAppearance: 'figcaption',
    },
];
// Generates a set of components(Typography Elements) based on the data in typographyElementsToGenerate
var generateComponents = function (componentsToGenerate) {
    return componentsToGenerate.reduce(function (acc, componentTemplateData) {
        var _a;
        var displayName = componentTemplateData.displayName, semanticTag = componentTemplateData.semanticTag, defaultVisualAppearance = componentTemplateData.defaultVisualAppearance;
        var TypographyElement = function (componentProps) {
            var visualAppearance = componentProps.visualAppearance, children = componentProps.children, className = componentProps.className, style = componentProps.style;
            return (react_1.default.createElement(Typography_1.default, { semanticTag: semanticTag, visualAppearance: visualAppearance || defaultVisualAppearance, className: className, style: style }, children));
        };
        TypographyElement.displayName = displayName;
        return __assign(__assign({}, acc), (_a = {}, _a[displayName] = TypographyElement, _a));
    }, {});
};
exports.Heading1 = (_a = generateComponents(typographyElementsToGenerate), _a.Heading1), exports.Heading2 = _a.Heading2, exports.Heading3 = _a.Heading3, exports.Heading4 = _a.Heading4, exports.Heading5 = _a.Heading5, exports.Heading6 = _a.Heading6, exports.BodyOneText = _a.BodyOneText, exports.BodyTwoText = _a.BodyTwoText, exports.BodyThreeText = _a.BodyThreeText, exports.BodyFourText = _a.BodyFourText, exports.OverlineOneText = _a.OverlineOneText, exports.OverlineTwoText = _a.OverlineTwoText, exports.OverlineThreeText = _a.OverlineThreeText, exports.EmText = _a.EmText, exports.StrongText = _a.StrongText, exports.ExtraStrongText = _a.ExtraStrongText, exports.Figcaption = _a.Figcaption;
